/* eslint-disable */
/**
 * MOBILE_FLOOR_LAYOUTS
 * Dữ liệu mặt bằng mobile, tách biệt theo Toà A / Toà B cho từng nhóm tầng.
 *
 * SVG paths lấy từ src/assets/images/plan/mobile/svg/
 * bedroomType / timTuong / thongThuy tái sử dụng từ FLOOR_LAYOUTS (desktop).
 *
 * Ghi chú tầng:
 *   - 8-12A Toà A : dùng plan-3-7-A (SVG paths giống SVG-8-12-A; chưa có plan-8-12-A.png riêng)
 *   - 22          : chỉ có Toà B
 */

import images from "@assets/images";

// ─────────────────────────────────────────────────────────────
// 3-7 — Toà A (viewBox: 0 0 1392 1050)
// ─────────────────────────────────────────────────────────────
const BLOCK_3_7_A = {
  planImage: images.mobilePlan_3_7_A,
  svgViewBox: "0 0 1392 1050",
  apartments: {
    "A-01": { svgPath: "M352 23h198v277H352V23Z",       timTuong: 49.46, thongThuy: 45.48, bedroomType: "1PN+" },
    "A-02": { svgPath: "M550 23h195v277H550V23Z",       timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+" },
    "A-03": { svgPath: "M745 23h195v277H745V23Z",       timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+" },
    "A-04": { svgPath: "M940 23h195v277H940V23Z",       timTuong: 48.82, thongThuy: 45.45, bedroomType: "1PN+" },
    "A-05": { svgPath: "M1135 0h242v300h-242V0Z",       timTuong: 66.06, thongThuy: 60.40, bedroomType: "2PN"  },
    "A-06": { svgPath: "M1192 353h200v276h-200V353Z",   timTuong: 49.99, thongThuy: 45.25, bedroomType: "1PN+" },
    "A-07": { svgPath: "M998 353h194v276H998V353Z",     timTuong: 48.82, thongThuy: 45.16, bedroomType: "1PN+" },
    "A-08": { svgPath: "M800 353h198v276H800V353Z",     timTuong: 48.90, thongThuy: 45.25, bedroomType: "1PN+" },
    "A-09": { svgPath: "M352 621h245v190H352V621Z",     timTuong: 43.09, thongThuy: 39.26, bedroomType: "1PN"  },
    "A-10": { svgPath: "M352 811h276v207H352V811Z",     timTuong: 50.48, thongThuy: 45.90, bedroomType: "1PN_GOC" },
    "A-11": { svgPath: "M22 851h278v199H22V851Z",       timTuong: 49.99, thongThuy: 45.45, bedroomType: "1PN_GOC" },
    "A-12": { svgPath: "M22 656h278v195H22V656Z",       timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+" },
    "A-13": { svgPath: "M22 461h278v195H22V461Z",       timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+" },
    "A-14": { svgPath: "M22 266h278v195H22V266Z",       timTuong: 49.24, thongThuy: 45.74, bedroomType: "1PN+" },
    "A-15": { svgPath: "M0 23h300v243H0V23Z",           timTuong: 66.31, thongThuy: 60.09, bedroomType: "2PN"  },
  },
};

// ─────────────────────────────────────────────────────────────
// 3-7 — Toà B (viewBox: 0 0 1434 1027)
// ─────────────────────────────────────────────────────────────
const BLOCK_3_7_B = {
  planImage: images.mobilePlan_3_7_B,
  svgViewBox: "0 0 1434 1027",
  apartments: {
    "B-01": { svgPath: "M1079.99 429.999H834.994v-190h244.996v190Z",    timTuong: 43.09, thongThuy: 39.24, bedroomType: "1PN"    },
    "B-02": { svgPath: "M1079.99 239.999H803.994v-207h275.996v207Z",    timTuong: 50.41, thongThuy: 45.80, bedroomType: "1PN_GOC" },
    "B-03": { svgPath: "M1409.99 199.999h-278v-199h278v199Z",           timTuong: 49.99, thongThuy: 45.45, bedroomType: "1PN_GOC" },
    "B-04": { svgPath: "M1409.99 394.999h-278v-195h278v195Z",           timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-05": { svgPath: "M1409.99 589.999h-278v-195h278v195Z",           timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-06": { svgPath: "M1409.99 784.999h-278v-195h278v195Z",           timTuong: 49.24, thongThuy: 46.03, bedroomType: "1PN+"   },
    "B-07": { svgPath: "M1431.99 1028h-300V784.999h300V1028Z",          timTuong: 66.31, thongThuy: 60.32, bedroomType: "2PN_2"  },
    "B-08": { svgPath: "M1079.99 1028H881.994V750.999h197.996V1028Z",   timTuong: 49.46, thongThuy: 45.48, bedroomType: "1PN+"   },
    "B-09": { svgPath: "M881.994 1028h-195V750.999h195V1028Z",          timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-10": { svgPath: "M686.994 1028h-195V750.999h195V1028Z",          timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-11": { svgPath: "M491.994 1028h-195V750.999h195V1028Z",          timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-12": { svgPath: "M296.994 1028h-199V751h199v277Z",               timTuong: 49.94, thongThuy: 45.37, bedroomType: "1PN+"   },
    "B-13": { svgPath: "M239.994 697.999h-242v-299h242v299Z",           timTuong: 66.32, thongThuy: 60.23, bedroomType: "2PN"    },
    "B-14": { svgPath: "M433.994 697.999h-194v-276h194v276Z",           timTuong: 48.82, thongThuy: 45.19, bedroomType: "1PN+"   },
    "B-15": { svgPath: "M631.994 697.999h-198v-276h198v276Z",           timTuong: 48.91, thongThuy: 45.25, bedroomType: "1PN+"   },
  },
};

// ─────────────────────────────────────────────────────────────
// 8-12A — Toà A (viewBox: 0 0 1392 1050)
// SVG paths từ SVG-8-12-A.svg — metadata từ FLOOR_LAYOUTS desktop 8-12A
// ─────────────────────────────────────────────────────────────
const BLOCK_8_12_A = {
  planImage: images.mobilePlan_3_7_A,
  svgViewBox: "0 0 1392 1050",
  apartments: {
    "A-01": { svgPath: "M352 23h198v277H352V23Z",       timTuong: 49.46, thongThuy: 45.48, bedroomType: "1PN+" },
    "A-02": { svgPath: "M550 23h195v277H550V23Z",       timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+" },
    "A-03": { svgPath: "M745 23h195v277H745V23Z",       timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+" },
    "A-04": { svgPath: "M940 23h195v277H940V23Z",       timTuong: 48.82, thongThuy: 45.45, bedroomType: "1PN+" },
    "A-05": { svgPath: "M1135 0h242v300h-242V0Z",       timTuong: 66.06, thongThuy: 60.45, bedroomType: "2PN"  },
    "A-06": { svgPath: "M1192 353h200v276h-200V353Z",   timTuong: 49.99, thongThuy: 45.41, bedroomType: "1PN+" },
    "A-07": { svgPath: "M998 353h194v276H998V353Z",     timTuong: 48.82, thongThuy: 45.24, bedroomType: "1PN+" },
    "A-08": { svgPath: "M800 353h198v276H800V353Z",     timTuong: 48.90, thongThuy: 45.28, bedroomType: "1PN+" },
    "A-09": { svgPath: "M352 621h245v190H352V621Z",     timTuong: 43.09, thongThuy: 39.26, bedroomType: "1PN"  },
    "A-10": { svgPath: "M352 811h276v207H352V811Z",     timTuong: 50.48, thongThuy: 45.90, bedroomType: "1PN_GOC" },
    "A-11": { svgPath: "M22 851h278v199H22V851Z",       timTuong: 49.99, thongThuy: 45.45, bedroomType: "1PN_GOC" },
    "A-12": { svgPath: "M22 656h278v195H22V656Z",       timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+" },
    "A-13": { svgPath: "M22 461h278v195H22V461Z",       timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+" },
    "A-14": { svgPath: "M22 266h278v195H22V266Z",       timTuong: 49.24, thongThuy: 45.74, bedroomType: "1PN+" },
    "A-15": { svgPath: "M0 23h300v243H0V23Z",           timTuong: 66.31, thongThuy: 60.09, bedroomType: "2PN"  },
  },
};

// ─────────────────────────────────────────────────────────────
// 8-12A — Toà B (viewBox: 0 0 1434 1027)
// SVG paths giải mã từ SVG-8-12-B.svg (combined path format)
// ─────────────────────────────────────────────────────────────
const BLOCK_8_12_B = {
  planImage: images.mobilePlan_8_12_B,
  svgViewBox: "0 0 1434 1027",
  apartments: {
    "B-01": { svgPath: "M1082 429H837V239h245v190Z",        timTuong: 43.09, thongThuy: 39.24, bedroomType: "1PN"    },
    "B-02": { svgPath: "M1082 239H806V32h276v207Z",         timTuong: 50.41, thongThuy: 45.80, bedroomType: "1PN_GOC" },
    "B-03": { svgPath: "M1412 199h-278V0h278v199Z",         timTuong: 49.99, thongThuy: 45.45, bedroomType: "1PN_GOC" },
    "B-04": { svgPath: "M1412 394h-278V199h278v195Z",       timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-05": { svgPath: "M1412 589h-278v-195h278v195Z",      timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-06": { svgPath: "M1412 784h-278V589h278v195Z",       timTuong: 49.24, thongThuy: 46.03, bedroomType: "1PN+"   },
    "B-07": { svgPath: "M1434 1027h-300V784h300v243Z",      timTuong: 66.31, thongThuy: 60.32, bedroomType: "2PN_2"  },
    "B-08": { svgPath: "M1082 1027H884V750h198v277Z",       timTuong: 49.46, thongThuy: 45.48, bedroomType: "1PN+"   },
    "B-09": { svgPath: "M884 1027H689V750h195v277Z",        timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-10": { svgPath: "M689 1027H494V750h195v277Z",        timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-11": { svgPath: "M494 1027H299V750h195v277Z",        timTuong: 48.82, thongThuy: 45.54, bedroomType: "1PN+"   },
    "B-12": { svgPath: "M299 1027H100V750h199V1027Z",       timTuong: 49.94, thongThuy: 45.37, bedroomType: "1PN+"   },
    "B-13": { svgPath: "M242 697H0V398h242v299Z",           timTuong: 66.32, thongThuy: 60.28, bedroomType: "2PN"    },
    "B-14": { svgPath: "M436 697H242V421h194v276Z",         timTuong: 48.82, thongThuy: 45.27, bedroomType: "1PN+"   },
    "B-15": { svgPath: "M634 697H436V421h198v276Z",         timTuong: 48.91, thongThuy: 45.27, bedroomType: "1PN+"   },
  },
};

// ─────────────────────────────────────────────────────────────
// 14-21 — Toà A (viewBox: 0 0 1392 1050)
// ─────────────────────────────────────────────────────────────
const BLOCK_14_21_A = {
  planImage: images.mobilePlan_14_21_A,
  svgViewBox: "0 0 1392 1050",
  apartments: {
    "A-01": { svgPath: "M352 23h198v277H352V23Z",       timTuong: 49.46, thongThuy: 45.62, bedroomType: "1PN+" },
    "A-02": { svgPath: "M550 23h195v277H550V23Z",       timTuong: 48.82, thongThuy: 45.64, bedroomType: "1PN+" },
    "A-03": { svgPath: "M745 23h195v277H745V23Z",       timTuong: 48.82, thongThuy: 45.64, bedroomType: "1PN+" },
    "A-04": { svgPath: "M940 23h195v277H940V23Z",       timTuong: 48.82, thongThuy: 45.49, bedroomType: "1PN+" },
    "A-05": { svgPath: "M1135 0h242v300h-242V0Z",       timTuong: 66.06, thongThuy: 60.81, bedroomType: "2PN"  },
    "A-06": { svgPath: "M1192 353h200v276h-200V353Z",   timTuong: 49.99, thongThuy: 45.72, bedroomType: "1PN+" },
    "A-07": { svgPath: "M998 353h194v276H998V353Z",     timTuong: 48.82, thongThuy: 45.48, bedroomType: "1PN+" },
    "A-08": { svgPath: "M800 353h198v276H800V353Z",     timTuong: 48.90, thongThuy: 45.34, bedroomType: "1PN+" },
    "A-09": { svgPath: "M352 621h245v190H352V621Z",     timTuong: 43.09, thongThuy: 39.38, bedroomType: "1PN"  },
    "A-10": { svgPath: "M352 811h276v207H352V811Z",     timTuong: 50.48, thongThuy: 46.24, bedroomType: "1PN_GOC" },
    "A-11": { svgPath: "M22 851h278v199H22V851Z",       timTuong: 49.99, thongThuy: 45.73, bedroomType: "1PN_GOC" },
    "A-12": { svgPath: "M22 656h278v195H22V656Z",       timTuong: 48.82, thongThuy: 45.63, bedroomType: "1PN+" },
    "A-13": { svgPath: "M22 461h278v195H22V461Z",       timTuong: 48.82, thongThuy: 45.63, bedroomType: "1PN+" },
    "A-14": { svgPath: "M22 266h278v195H22V266Z",       timTuong: 49.24, thongThuy: 45.87, bedroomType: "1PN+" },
    "A-15": { svgPath: "M0 23h300v243H0V23Z",           timTuong: 66.31, thongThuy: 60.49, bedroomType: "2PN"  },
  },
};

// ─────────────────────────────────────────────────────────────
// 14-21 — Toà B (viewBox: 0 0 1434 1027)
// ─────────────────────────────────────────────────────────────
const BLOCK_14_21_B = {
  planImage: images.mobilePlan_14_21_B,
  svgViewBox: "0 0 1434 1027",
  apartments: {
    "B-01": { svgPath: "M1082 429H837V239h245v190Z",        timTuong: 43.09, thongThuy: 39.36, bedroomType: "1PN"    },
    "B-02": { svgPath: "M1082 239H806V32h276v207Z",         timTuong: 50.41, thongThuy: 46.14, bedroomType: "1PN_GOC" },
    "B-03": { svgPath: "M1412 199h-278V0h278v199Z",         timTuong: 49.99, thongThuy: 45.73, bedroomType: "1PN_GOC" },
    "B-04": { svgPath: "M1412 394h-278V199h278v195Z",       timTuong: 48.82, thongThuy: 45.64, bedroomType: "1PN+"   },
    "B-05": { svgPath: "M1412 589h-278V394h278v195Z",       timTuong: 48.82, thongThuy: 45.64, bedroomType: "1PN+"   },
    "B-06": { svgPath: "M1412 784h-278V589h278v195Z",       timTuong: 49.24, thongThuy: 46.13, bedroomType: "1PN+"   },
    "B-07": { svgPath: "M1434 1027h-300V784h300v243Z",      timTuong: 66.31, thongThuy: 60.64, bedroomType: "2PN_2"  },
    "B-08": { svgPath: "M1082 1027H884V750h198v277Z",       timTuong: 49.46, thongThuy: 45.62, bedroomType: "1PN+"   },
    "B-09": { svgPath: "M884 1027H689V750h195v277Z",        timTuong: 48.82, thongThuy: 45.63, bedroomType: "1PN+"   },
    "B-10": { svgPath: "M689 1027H494V750h195v277Z",        timTuong: 48.82, thongThuy: 45.63, bedroomType: "1PN+"   },
    "B-11": { svgPath: "M494 1027H299V750h195v277Z",        timTuong: 48.82, thongThuy: 45.63, bedroomType: "1PN+"   },
    "B-12": { svgPath: "M299 1027H100V750.001h199V1027Z",   timTuong: 49.94, thongThuy: 45.62, bedroomType: "1PN+"   },
    "B-13": { svgPath: "M242 697H0V398h242v299Z",           timTuong: 66.32, thongThuy: 60.64, bedroomType: "2PN"    },
    "B-14": { svgPath: "M436 697H242V421h194v276Z",         timTuong: 48.82, thongThuy: 45.49, bedroomType: "1PN+"   },
    "B-15": { svgPath: "M634 697H436V421h198v276Z",         timTuong: 48.91, thongThuy: 45.33, bedroomType: "1PN+"   },
  },
};

// ─────────────────────────────────────────────────────────────
// 22 — Toà B only
// SVG paths từ SVG-22-B.svg (viewBox 945×1027), dịch +489px theo trục X
// để khớp plan-22-B.png (1434×1029) — cùng hệ tọa độ với các block B khác.
// ─────────────────────────────────────────────────────────────
const BLOCK_22_B = {
  planImage: images.mobilePlan_22_B,
  svgViewBox: "0 0 1434 1027",
  apartments: {
    "B-01": { svgPath: "M1082 429H837V239h245v190Z",         timTuong: 43.09, thongThuy: 39.36, bedroomType: "1PN"    },
    "B-02": { svgPath: "M1082 239H806V32h276v207Z",          timTuong: 50.41, thongThuy: 46.24, bedroomType: "1PN_GOC" },
    "B-03": { svgPath: "M1412 199H1134V0h278v199Z",          timTuong: 49.99, thongThuy: 45.73, bedroomType: "1PN_GOC" },
    "B-04": { svgPath: "M1412 394H1134V199h278v195Z",       timTuong: 48.82, thongThuy: 45.63, bedroomType: "1PN+"   },
    "B-05": { svgPath: "M1412 589H1134V394h278v195Z",       timTuong: 48.82, thongThuy: 45.63, bedroomType: "1PN+"   },
    "B-06": { svgPath: "M1412 784H1134V589h278v195Z",       timTuong: 49.24, thongThuy: 46.13, bedroomType: "1PN+"   },
    "B-07": { svgPath: "M1434 1027H1134V784h300v243Z",      timTuong: 66.31, thongThuy: 60.64, bedroomType: "2PN_2"  },
    "B-08": { svgPath: "M1082 1027H884V750h198v277Z",       timTuong: 49.46, thongThuy: 45.62, bedroomType: "1PN+"   },
    "B-09": { svgPath: "M884 1027H489V750h395v277Z",        timTuong: 98.89, thongThuy: 93.10, bedroomType: "3PN"    },
  },
};

// ─────────────────────────────────────────────────────────────
// Main export — key khớp với LAYOUT_GROUPS id
// ─────────────────────────────────────────────────────────────
export const MOBILE_FLOOR_LAYOUTS = {
  "3-7":   { A: BLOCK_3_7_A,   B: BLOCK_3_7_B   },
  "8-12A": { A: BLOCK_8_12_A, B: BLOCK_8_12_B },
  "14-21": { A: BLOCK_14_21_A, B: BLOCK_14_21_B },
  "22":    {                    B: BLOCK_22_B    }, // Toà B only
};
